// Translation for en
export const km = {
        common: {
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            delete: 'Delete',
            edit: 'Edit',
            activate: 'Activate',
            add: 'Add',
            saving: 'Saving...',
            loading: 'Loading...',
            active: 'ACTIVE',
            inUse: 'In Use',
            test: 'Test',
            searchApps: 'Search apps...',
            betaBanner: 'BETA - Service not available yet!'
        },
        header: {
            creditBalance: 'Balance',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Sign In',
            signUp: 'Sign Up',
            username: 'Username',
            password: 'Password',
            continue: 'Continue',
            noAccount: 'Don\'t have an account?',
            hasAccount: 'Already have an account?',
            loginError: 'Login failed',
            invalidCredentials: 'Invalid username or password',
            rateLimited: 'Too many login attempts. Please wait a moment.',
            sessionExpired: 'Your session has expired. Please use a new magic link.',
            magicLinkInvalid: 'The login link is invalid or has expired.',
            magicLinkSuccess: 'Welcome! You have been successfully logged in.',
            magicLinkProcessing: 'Processing login...',
            connectionError: 'Connection error. Please try again.'
        },
        profile: {
            myProgress: 'My Learning Progress',
            signOut: 'Sign Out',
            plan: 'Plan: '
        },
        settings: {
            title: 'Settings',
            tabs: {
                uiSettings: 'UI Settings',
                systemPrompt: 'System Prompt',
                llmProfiles: 'LLM Profiles',
                ttsProfiles: 'TTS Profiles',
                language: 'Language',
            },
            uiSettings: {
                title: 'User Interface',
                themeMode: 'Theme Mode',
                darkMode: 'Dark Mode',
                lightMode: 'Light Mode',
                themeColor: 'Theme Color',
                themeColorDesc: 'Choose the accent color for buttons, icons and highlights',
                background: 'Background',
                backgroundDesc: 'Choose a background for your workspace',
                selectBackgroundColor: 'Select Background Color',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Focus',
                    concentration: 'Concentration',
                    relaxation: 'Relaxation',
                    lianas: 'Lianas',
                    color: 'Color'
                },
                backgroundColors: {
                    deepDark: 'Deep Dark',
                    darkGrey: 'Dark Grey',
                    midnightBlue: 'Midnight Blue',
                    indigo: 'Indigo',
                    darkTeal: 'Dark Teal',
                    brown: 'Brown',
                    darkRed: 'Dark Red',
                    deepPurple: 'Deep Purple',
                    pureWhite: 'Pure White',
                    softWhite: 'Soft White',
                    lightGrey: 'Light Grey',
                    paleBlue: 'Pale Blue',
                    paleGreen: 'Pale Green',
                    paleOrange: 'Pale Orange',
                    lavender: 'Lavender',
                    blueGrey: 'Blue Grey'
                }
            },
            systemPrompt: {
                label: 'System Prompt:',
                placeholder: 'Loading system prompt...',
                emptyError: 'System prompt cannot be empty!',
                saveSuccess: '✓ System prompt saved successfully!',
                loadError: 'Error loading system prompt',
                saveError: 'Error saving'
            },
            llmProfiles: {
                addButton: '+ Add New Connection',
                newConnection: 'New Connection',
                editConnection: 'Edit Connection',
                emptyState: 'No LLM connections available. Click below to add one.',
                loadingProfiles: 'Loading profiles...',
                nameLabel: 'Name *',
                namePlaceholder: 'e.g. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ Profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                profileNotFound: 'Profile not found!',
                loadError: 'Error loading profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Add New Voice',
                newVoice: 'New Voice',
                editVoice: 'Edit Voice',
                emptyState: 'No TTS profiles available. Click below to add one.',
                loadingProfiles: 'Loading TTS profiles...',
                nameLabel: 'Name',
                namePlaceholder: 'e.g. My ElevenLabs Adam',
                providerLabel: 'Provider',
                providerPlaceholder: 'e.g. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model ID *',
                modelIdPlaceholder: 'e.g. eleven_monolingual_v1',
                voiceIdLabel: 'Voice ID',
                voiceIdPlaceholder: 'e.g. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ TTS profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                loadError: 'Error loading TTS profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting'
            },
            language: {
                title: 'Choose Language',
                description: 'Select your preferred language for the user interface'
            },
        },
        chat: {
            ready: 'Ready',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Click START for real-time conversation.',
            listening: 'Listening...',
            speaking: 'Thorsten is speaking...',
            userLabel: 'You',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Type a message...',
            send: 'Send',
            loginRequired: 'Please sign in to use this service.',
            loginButton: 'Sign In Now',
            magicLinkRequired: 'Please use a magic link to sign in.',
            creditLimitError: 'Your hourly quota has been exhausted. Please upgrade your plan (Medium/Premium) to continue.',
            serviceDisabled: 'សេវាកម្មជជែកបច្ចុប្បន្នមិនអាចប្រើបានទេ។ សូមព្យាយាមម្ដងទៀតនៅពេលក្រោយ។'
        },
        notifications: {
            error: 'Error',
            success: 'Success',
            info: 'Information',
            unknownError: 'An unknown error occurred'
        },
        cookie: {
            message: 'This website uses cookies to provide you with the best possible user experience.',
            accept: 'Accept'
        },
        curriculum: {
                buttonLabel: 'កម្មវិធីសិក្សា',
                buttonTitle: 'បង្ហាញខ្លឹមសារកម្មវិធីសិក្សា',
                modalTitle: 'កម្មវិធីសិក្សា {app}',
                sections: {
                    topic: 'ប្រធានបទកម្មវិធីសិក្សា',
                    explanation: 'ការពន្យល់សម្រាប់កុមារ',
                    studentProfile: 'ទម្រង់សិស្ស'
                },
                topic: {
                    empty: 'មិនមានប្រធានបទកម្មវិធីសិក្សាដែលភ្ជាប់ទៅកម្មវិធីតូចនេះនៅក្នុងប្រព័ន្ធខាងក្រោយទេ។',
                    missingDetail: 'ព័ត៌មានលម្អិតនៃកម្មវិធីសិក្សាសម្រាប់កម្មវិធីតូចនេះមិនទាន់មាននៅក្នុងប្រព័ន្ធខាងក្រោយទេ។',
                    learningGoals: 'គោលដៅសិក្សា',
                    prerequisites: 'តម្រូវការមុន',
                    unitLabel: 'ឯកតា',
                    durationLabel: 'រយៈពេល',
                    difficultyLabel: 'កម្រិតលំបាក',
                    hours: 'ម៉ោង',
                    minutes: 'នាទី'
                },
                explanation: {
                    empty: 'មិនមានការពន្យល់សម្រាប់កុមារទេ។',
                    loadingPrepare: 'AI កំពុងរៀបចំការពន្យល់',
                    loadingExplain: 'AI កំពុងពន្យល់ប្រធានបទជាភាសាសម្រាប់កុមារ',
                    requestFailed: 'មិនអាចបង្កើតការពន្យល់សម្រាប់កុមារបានទេ។'
                },
                studentProfile: {
                    country: 'ប្រទេស',
                    region: 'រដ្ឋ / តំបន់',
                    schoolType: 'ប្រភេទសាលា',
                    grade: 'ថ្នាក់',
                    noContext: 'មិនមានបរិបទសិស្សទេ។',
                    childProfileNotFound: 'មិនមានទម្រង់សិស្សនៅក្នុងប្រព័ន្ធខាងក្រោយសម្រាប់ការចូលបច្ចុប្បន្នទេ។',
                    loginProfileIncomplete: 'ទម្រង់ចូលមិនទាន់មានបរិបទសិស្សពេញលេញទេ។',
                    educationContextNotFound: 'បានរកឃើញទម្រង់សិស្ស ប៉ុន្តែមិនមានការកំណត់កម្មវិធីសិក្សាទេ។',
                    noToken: 'មិនមានសិស្សដែលបានចូលទេ។'
                },
                errors: {
                    signInRequired: 'សូមចូលដើម្បីមើលកម្មវិធីសិក្សា។',
                    appIdMissing: 'បាត់លេខសម្គាល់កម្មវិធី។',
                    loadFailed: 'មិនអាចផ្ទុកទិន្នន័យកម្មវិធីសិក្សាបានទេ។'
                }
            }
    };
